var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContentLeftAlign = function SvgContentLeftAlign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3a1 1 0 0 1-1 1H1a1 1 0 0 1 0-2h6a1 1 0 0 1 1 1Zm3 6a1 1 0 1 0 0-2H1a1 1 0 0 0 0 2h10ZM1 14h14a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2Z"
  })));
};
export default SvgContentLeftAlign;